<template>
  <div id="app" class="char-detail" data-page="char-detail">
    <div class="char-detail-wrap">
      <!-- 切换箭头 -->
      <div class="char-detail__arrow"></div>
      <div class="char-detail__content">
        <!-- 左半部角色图片 -->
        <div class="char-detail__left">
          <!-- 进化前 -->
          <div class="char-detail__img char-detail__img--skt"></div>
          <!-- 进化后 -->
          <div
            class="char-detail__img__after char-detail__img__after--skt"
          ></div>
          <!-- 切换进化前后按钮 -->
          <div class="cher-detail__switch__img"></div>
          <div class="cher-detail__switch__img__after"></div>
        </div>
        <!-- 右半部角色介绍 -->
        <div class="char-detail__right">
          <div class="char-detail__name__voice-box">
            <div class="char-detail__name char-detail__name--skt"></div>
            <ul class="char-detail__voice-list">
              <li class="char-detail__voice char-detail__voice--skt"></li>
              <li class="char-detail__voice char-detail__voice--skt"></li>
              <li class="char-detail__voice char-detail__voice--skt"></li>
            </ul>
          </div>
          <div class="char-detail__cv char-detail__cv--skt"></div>
          <div class="char-detail__info-box">
            <div
              class="char-detail__info char-detail__info-gender char-detail__info--skt"
            >
              <span>性别</span>
              <span></span>
            </div>
            <div
              class="char-detail__info char-detail__info-type char-detail__info--skt"
            >
              <span>类型</span>
              <span></span>
            </div>
            <div
              class="char-detail__info char-detail__info-rare char-detail__info--skt"
            >
              <span>罕见</span>
              <span></span>
            </div>
            <div
              class="char-detail__info char-detail__info-race char-detail__info--skt"
            >
              <span>种族</span>
              <span></span>
            </div>
            <div
              class="char-detail__info char-detail__info-type char-detail__info--skt"
            >
              <span>属性</span>
              <span></span>
            </div>
          </div>
          <div class="char-detail__skill-box">
            <div class="char-detail__skill-title">技能</div>
            <div class="char-detail__skill-text char-detail__skill-text--skt">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="char-detail__store-box">
            <div class="char-detail__store-title">说明</div>
            <div
              class="char-detail__store-text char-detail__store-title--skt"
            ></div>
          </div>
          <!-- 下载图片按钮 -->
          <div calss="char-detail__loadBtn-box">
            <!-- 技能动图 -->
            <a href="javascript:;" download="" class="loadBtn1"></a>
            <!-- 进化前立绘 -->
            <a href="javascript:;" download="" class="loadBtn2"></a>
            <!-- 进化后立绘 -->
            <a href="javascript:;" download="" class="loadBtn3"></a>
          </div>
          <div class="char-detail__video"></div>
        </div>
      </div>
      <!-- 回脚色列表页 -->
      <router-link :to="{ path: '/character' }" class="char-detail__index" />
    </div>
  </div>
</template>
<script>
import { articleDetail } from "@api/index";
import { VUE_APP_API_URL } from "@utils/index";
import {
  propertyNumNameChange,
  propertyNameChange,
  dataErr,
  getQuery
} from "@assets/js/common";
let NAME = "CharacterDetail";

export default {
  name: "CharacterDetail",
  components: {},
  data() {
    return {
      baseUrl: VUE_APP_API_URL,
      loadGif: "", // 缩略动图
      loadImageBefore: "", // 进化前立绘
      loadImageAfter: "" // 进化后立绘
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.initData();
      }
    }
  },
  mounted: function() {
    window.$("#LT_age").remove();
    let that = this;
    let audio;
    that.initData();
    // 切换进化前后按钮方法
    that.$("body").on("click", ".cher-detail__switch__img", function() {
      that.$(".char-detail__img__after").fadeIn(300);
      that.$(".char-detail__img").fadeOut(300);
      that.$(".cher-detail__switch__img__after").show();
      that.$(".cher-detail__switch__img").hide();
    });
    that.$("body").on("click", ".cher-detail__switch__img__after", function() {
      that.$(".char-detail__img").fadeIn(300);
      that.$(".char-detail__img__after").fadeOut(300);
      that.$(".cher-detail__switch__img__after").hide();
      that.$(".cher-detail__switch__img").show();
    });
    that.$("body").on("click", ".loadBtn1", function() {
      that.downloadFile(that.loadGif);
    });
    that.$("body").on("click", ".loadBtn2", function() {
      that.downloadFile(that.loadImageBefore);
    });
    that.$("body").on("click", ".loadBtn3", function() {
      that.downloadFile(that.loadImageAfter);
    });

    that.$("body").on("click", ".char-detail__voice", function() {
      let audioLink;
      if (audio) {
        audio.pause();
        audio = null;
        that.$(".char-detail__voice").removeClass("playing");
        if (!that.$(this).hasClass("playing")) {
          audioLink = that.$(this).attr("data-voice");
          audio = new Audio(audioLink);
          audio.play();
          that.$(this).addClass("playing");
        }
      } else {
        audioLink = that.$(this).attr("data-voice");
        audio = new Audio(audioLink);
        audio.play();
      }
      that.$(audio).on("ended", function() {
        if (audio) {
          audio.pause();
          audio = null;
          that.$(this).removeClass("playing");
        }
      });
    });
    // that.$(".cher-detail__switch__img").unbind("click");
  },
  methods: {
    downloadFile(filenamerel) {
      var $downForm = window.$("<form method='get' target='_blank'></form>");
      $downForm.attr("action", this.baseUrl + filenamerel);
      var $input = window.$("<input type='hidden'>");
      $input.attr("name", "filenamerel");
      $input.val(this.baseUrl + filenamerel);
      $downForm.append($input);
      window.$(document.body).append($downForm);
      //提交表单，实现下载
      $downForm.submit();
    },
    initData() {
      let that = this;
      articleDetail({
        Seq: that.$route.query.id,
        Rarity: that.$route.query.rarity,
        Property: that.$route.query.property,
        class_id: 1,
        id: that.$route.query.id
      }).then(res => {
        var charDetailList = res;
        var charArrowList = [];
        if (
          res.pre &&
          Object.prototype.toString.call(res.pre) === "[object Array]"
        ) {
          charArrowList[0] = {};
        } else {
          res.pre.characterLogo = res.pre.player_head_img;
          res.pre.seq = res.pre.content_id;

          charArrowList[0] = res.pre;
        }
        if (
          res.next &&
          Object.prototype.toString.call(res.next) === "[object Array]"
        ) {
          charArrowList[1] = {};
        } else {
          res.next.characterLogo = res.next.player_head_img;
          res.next.seq = res.next.content_id;
          charArrowList[1] = res.next;
        }
        // 格式化数据

        charDetailList.voice1 = charDetailList.player_audio1;
        charDetailList.voice2 = charDetailList.player_audio2;
        charDetailList.voice3 = charDetailList.player_audio3;

        charDetailList.characterDescription = that
          .$("<div>")
          .html(charDetailList.detail)
          .text();
        charDetailList.characterGif = charDetailList.pic;
        charDetailList.characterImage = charDetailList.player_img;
        charDetailList.characterImage2 = charDetailList.player_img2;
        charDetailList.characterLogo = charDetailList.player_head_img;
        charDetailList.characterName = charDetailList.title;
        charDetailList.characterVoice = charDetailList.cv_desc;

        switch (charDetailList.sex) {
          case 0:
            charDetailList.genderName = "女性";
            break;
          case 1:
            charDetailList.genderName = "男性";

            break;
          case 2:
            charDetailList.genderName = "不明";

            break;
        }
        charDetailList.property = charDetailList.attributes;

        switch (charDetailList.property) {
          case "0":
            charDetailList.propertyName = "火";
            break;
          case "1":
            charDetailList.propertyName = "水";
            break;
          case "2":
            charDetailList.propertyName = "风";
            break;
          case "3":
            charDetailList.propertyName = "雷";
            break;
          case "4":
            charDetailList.propertyName = "光";
            break;
          case "5":
            charDetailList.propertyName = "暗";
            break;
          default:
            break;
        }

        charDetailList.raceName = charDetailList.ethnicity;
        // charDetailList.rarity = charDetailList.rarity;
        charDetailList.row = 3;
        charDetailList.seq = charDetailList.content_id;

        const skillName = that
          .$("<div>")
          .html(charDetailList.skill)
          .text();
        // 后端放话了，说一定是 两个p标签；他不给拆分，那就只能我拆分了！错了找他别找我
        const skillNameR = skillName.match(/<p>(.*?)<\/p>/gi);

        charDetailList.skillDescription = that
          .$("<div>")
          .html(skillNameR[1])
          .text();
        charDetailList.skillName = that
          .$("<div>")
          .html(skillNameR[0])
          .text();
        switch (charDetailList.type) {
          case 0:
            charDetailList.typeName = "剑士";
            break;
          case 1:
            charDetailList.typeName = "格斗";

            break;
          case 2:
            charDetailList.typeName = "特殊";

            break;
          case 3:
            charDetailList.typeName = "辅助";

            break;
          case 4:
            charDetailList.typeName = "射击";

            break;
        }

        charDetailList.videoUrl = "";

        if (!Object.keys(charDetailList).length) {
          that.$(".char-detail__arrow").html(that.charArrow(charArrowList));
          that.$(".char-detail__content").html(dataErr("暂无此角色资料"));
          return;
        }
        that
          .$(".char-detail__arrow")
          .html(that.charArrow(charArrowList, getQuery()));
        that
          .$(".char-detail__content")
          .html(that.charDetailRender(charDetailList));
        if (that.loadGif === "") {
          window.$(".loadBtn1").hide();
        }
        if (that.loadImageBefore === "") {
          window.$(".loadBtn2").hide();
        }
        if (that.loadImageAfter === "") {
          window.$(".loadBtn3").hide();
        }
      });
    },
    charArrow(data, charQuery) {
      let that = this;
      var charInfo = charQuery;
      var href1 = "character-detail?id=" + data[0].seq;
      var href2 = "character-detail?id=" + data[1].seq;
      if (charInfo.Rarity) {
        var Rarity = charInfo.Rarity;
        href1 += "&Rarity=" + Rarity;
        href2 += "&Rarity=" + Rarity;
      }
      if (charInfo.Property) {
        var Property = charInfo.Property;
        href1 += "&Property=" + Property;
        href2 += "&Property=" + Property;
      }
      var charArrowHTML = "";
      if (data[0].seq) {
        charArrowHTML =
          charArrowHTML +
          '<a href = "' +
          href1 +
          '" class="char-detail__prev" >\
                <div class="char-detail__prev-char ' +
          propertyNumNameChange(data[0].attributes).en +
          '">\
                    <div class="char-detail__prev-char-img">\
                        <img src="' +
          that.baseUrl +
          data[0].characterLogo +
          '" alt="">\
                    </div>\
                </div>\
            </a>\
            ';
      }

      if (data[1].seq) {
        charArrowHTML =
          charArrowHTML +
          '<a href="' +
          href2 +
          '" class="char-detail__next">\
                <div class="char-detail__next-char ' +
          propertyNumNameChange(data[1].attributes).en +
          '">\
                    <div class="char-detail__next-char-img">\
                        <img src="' +
          that.baseUrl +
          data[1].characterLogo +
          '" alt="">\
                    </div>\
                </div>\
            </a>';
      }
      return charArrowHTML;
    },
    charDetailRender(data) {
      let that = this;
      that.loadGif = data.player_gif_pic;
      that.loadImageBefore = data.player_img_watermark;
      that.loadImageAfter = data.player_img2_watermark;
      // that.loadImageAfter = "";
      var voiceArr = [];
      var voiceHTML = "";
      var videoUrl = data.videoUrl;
      var videoHTML = "";
      var characterVoiceHTML =
        '<div class="char-detail__cv" style="visibility: hidden;">CV:</div>';
      if (videoUrl) {
        var video = videoUrl.match(/([^v=]+)=([^=]*)/g)[0].split("&")[0];
        videoHTML =
          '<div class="char-detail__video">\
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/' +
          video +
          '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\
                </div>';
      }
      if (data.voice1 != "") {
        voiceArr.push(data.voice1);
      }
      if (data.voice2 != "") {
        voiceArr.push(data.voice2);
      }
      if (data.voice3 != "") {
        voiceArr.push(data.voice3);
      }
      if (voiceArr.length > 0) {
        voiceArr.forEach(function(voice) {
          voiceHTML +=
            '<li class="char-detail__voice" data-voice="' + voice + '"></li>';
        });
      }
      if (data.characterVoice !== "" || data.characterVoice === 0) {
        characterVoiceHTML =
          '<div class="char-detail__cv">CV:' + data.characterVoice + "</div>";
      }
      var charDetailHTML = `<div class="char-detail__left" >\
                <div class="char-detail__img">\
                    <img src="${that.baseUrl}${data.characterImage}" alt="">\
                </div>\
                <div class="char-detail__img__after" style="display: none">\
                <img src="${that.baseUrl}${data.characterImage2}" alt="">\
                </div>\
                <div class="cher-detail__switch__img"></div>\
                <div class="cher-detail__switch__img__after" style="display: none"></div>\
                <div class="char-detail__gif">\
                    <img src="${that.baseUrl}${data.characterGif}" alt="">\
                </div>\
            </div>\
            <div class="char-detail__right">\
                <div class="char-detail__name__voice-box">
                    <div class="char-detail__name">${data.characterName}</div>\
                    <ul class="char-detail__voice-list">${voiceHTML}</ul>\
                </div>
                ${characterVoiceHTML}\
                <div class="char-detail__info-box">\
                    <div class="char-detail__info char-detail__info-gender">\
                        <span>性别</span>\
                        <span>${data.genderName}</span>\
                    </div>\
                    <div class="char-detail__info char-detail__info-type">\
                        <span>类型</span>\
                        <span>${data.typeName}</span>\
                    </div>\
                    <div class="char-detail__info char-detail__info-rare">\
                        <span>稀有度</span>\
                        <span>${data.rarity}</span>\
                    </div>\
                    <div class="char-detail__info char-detail__info-race">\
                        <span>种族</span>\
                        <span>${data.raceName}</span>\
                    </div>\
                    <div class="char-detail__info char-detail__info-type ${
                      propertyNameChange(data.propertyName).en
                    }">\
                        <span>属性</span>\
                        <span>${data.propertyName}</span>\
                    </div>\
                </div>\
                <div class="char-detail__skill-box">\
                    <div class="char-detail__skill-title">技能</div>\
                    <div class="char-detail__skill-text">\
                        <span>${data.skillName}</span>\
                        <span>${data.skillDescription}</span>\
                    </div>\
                </div>\
                <div class="char-detail__store-box">\
                    <div class="char-detail__store-title">说明</div>\
                    <div class="char-detail__store-text">${
                      data.characterDescription
                    }</div>\
                </div>\
                <div class="char-detail__loadBtn-box">\
                    <a href="javascript:;" download class="loadBtn1"></a>\
                    <a href="javascript:;" download class="loadBtn2"></a>\
                    <a href="javascript:;" download class="loadBtn3"></a>\
                </div>\
                ${videoHTML}\
            </div>`;
      // ${that.baseUrl}${data.characterGif}
      return charDetailHTML;
    }
  }
};
</script>
<style scoped></style>
